import type { SocialPost } from '../api/client'

export type SocialShow = 'to_approve' | 'waiting' | 'posted' | 'needs_checking'

export const SOCIAL_TABS: { key: SocialShow; label: string }[] = [
  { key: 'to_approve', label: 'To approve' },
  { key: 'waiting', label: 'Waiting for the piece' },
  { key: 'posted', label: 'Posted' },
  { key: 'needs_checking', label: 'Needs checking' },
]

export const POSTING_OFF = "Posting isn't switched on yet. You can write and approve posts. Approved posts will go out once posting is switched on."

export function parseSocialShow(raw: string | null): SocialShow {
  return SOCIAL_TABS.some((t) => t.key === raw) ? (raw as SocialShow) : 'to_approve'
}

/** The banner while posting is off; null once it is on. */
export function bannerText(postingOn: boolean): string | null {
  return postingOn ? null : POSTING_OFF
}

/** Each tab's label with its count, e.g. "To approve 7". */
export function tabLabels(counts: Partial<Record<SocialShow, number>> | null | undefined): { key: SocialShow; label: string; count: number | null }[] {
  return SOCIAL_TABS.map((t) => ({ ...t, count: typeof counts?.[t.key] === 'number' ? (counts[t.key] as number) : null }))
}

export type PostActions = { save: boolean; rewrite: boolean; approve: boolean; drop: boolean; publish: boolean }

/** Which buttons a post card offers. `dirty` is an unsaved edit. A posted card has none. */
export function showActions(postingOn: boolean, post: Pick<SocialPost, 'status' | 'over_by' | 'publishable'>, dirty = false): PostActions {
  const done = post.status === 'published'
  return {
    save: !done && dirty,
    rewrite: !done,
    approve: !done && post.status !== 'approved' && post.over_by <= 0,
    drop: !done && post.status !== 'rejected',
    publish: !done && postingOn && post.publishable,
  }
}

/** Publish-all is offered only while posting is on and something approved can go. */
export function canPostApproved(postingOn: boolean, posts: Pick<SocialPost, 'status' | 'publishable'>[]): boolean {
  return postingOn && posts.some((p) => p.status === 'approved' && p.publishable)
}
